import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-password-update-success',
  templateUrl: './password-update-success.component.html',
  styleUrls: ['./password-update-success.component.scss'],
})
export class PasswordUpdateSuccessComponent implements OnInit {

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }

}
